module.exports = __webpack_public_path__ + "img/flisol.ad22ab79.jpg";